export const green = '#A5CD41';
export const greenHover = '#83A334';
export const gray = '#717E86';
export const lightGray = '#EFEFEF';
export const white = '#FFFFFF';
export const darkWhite = '#FAFAFA';
